var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanIconMinus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fc22a986-224d-4aea-9419-75c38bc25b17{fill:#0a1482;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e56084c6-8434-4f07-83bb-1a9f95169a83",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fc22a986-224d-4aea-9419-75c38bc25b17",
    d: "M170.83,114.17H29.17a14.17,14.17,0,0,1,0-28.34H170.83a14.17,14.17,0,0,1,0,28.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIconMinus);
export default __webpack_public_path__ + "static/media/LoanIcon_minus.f51f5b189990fc93f04e776bbc0e0081.svg";
export { ForwardRef as ReactComponent };